import styled from "styled-components";

export const UserOrdersTable = styled.table`
  border-collapse: separate;
  border-spacing: 0 12px;
  .status {
    font-size: var(--font-size-sm);
    @media screen and (max-width: 768px) {
      font-size: var(--font-size-xs);
    }
  }
  &.striped > tbody > tr:nth-of-type(odd) {
    & > * {
      background-color: var(--blue-color-light);
      &:first-child {
        border-top-right-radius: var(--border-radius-1);
        border-bottom-right-radius: var(--border-radius-1);
      }
      &:last-child {
        border-top-left-radius: var(--border-radius-1);
        border-bottom-left-radius: var(--border-radius-1);
      }
    }
  }
`;

export const UserOrdersTableHead = styled.thead`
  background: var(--field-color);
  color: white;
  border-radius: var(--border-radius-1);
  padding: 15px 5px;
  margin-top: 20px;
  height: 40px;
  & * {
    font-size: var(--font-size-sm);
  }
  tr th {
    &:first-child {
      border-top-right-radius: var(--border-radius-1);
      border-bottom-right-radius: var(--border-radius-1);
    }
    &:last-child {
      border-top-left-radius: var(--border-radius-1);
      border-bottom-left-radius: var(--border-radius-1);
    }
  }
`;

export const UserOrdersTableBody = styled.tr`
  width: 100%;
  box-shadow: 1px 6px 10px 2px rgba(62, 165, 219, 0.12);
  padding: 20px 5px;
  & * {
    font-size: var(--font-size-sm);
  }
`;

export const StatusFinancialBadge = styled.span`
  background: var(--secondary-color);
  padding: 5px 15px;
  border-radius: var(--border-radius-2);
  color: var(--blue-color-dark);
`;
